import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {PromoPanelGameConfiguration} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";

export class LonerNolimitPromotionPlugin extends NolimitPromotionPlugin{
    constructor(config?:PromoPanelGameConfiguration) {
        super(config);
    }

    //this close function is used to handle xBet when action spins is played and we come back to main game.
    close(isFeatureBuy?: boolean, isFreeBetTriggered?: boolean) {
        super.close(isFeatureBuy, isFreeBetTriggered);
    }
}